import { NgModule } from '@angular/core';

import { LaborProductsSearchControlComponent } from './products.labor-search.control.component';
import { ProductActionsComponent }             from './product.actions.component';
import { ProductBranchStockComponent }         from './product.branch-stock.component';
import { ProductComponent }                    from './product.component';
import { ProductGroupQuickAddComponent }       from './product-group.quick-add.component';
import { ProductIntegrationsService }          from './product-integrations.service';
import { ProductsAdvancedSearchComponent }     from './products.advanced-search.component';
import { ProductsListComponent }              from './products.list.component';
import { ProductSearchService }                from './product.search.service';
import { ProductService }                      from './product.service';
import { SharedModule }                        from '../shared/shared.module';
import { TableModule }                         from '../table/table.module';
import { VendorsModule }                       from '../vendors/vendors.module';

@NgModule({
  declarations: [
    LaborProductsSearchControlComponent,
    ProductBranchStockComponent,
    ProductActionsComponent,
    ProductComponent,
    ProductGroupQuickAddComponent,
    ProductsAdvancedSearchComponent,
    ProductsListComponent
  ],
  entryComponents: [
    LaborProductsSearchControlComponent,
    ProductBranchStockComponent,
    ProductActionsComponent,
    ProductComponent,
    ProductGroupQuickAddComponent,
    ProductsAdvancedSearchComponent,
    ProductsListComponent
  ],
  exports: [
    LaborProductsSearchControlComponent,
    ProductsListComponent
  ],
  imports: [
    SharedModule,
    TableModule,
    VendorsModule
  ],
  providers: [
    ProductIntegrationsService,
    ProductSearchService,
    ProductService
  ]
})
export class ProductsModule {}
